<template>
  <!-- 投资机构 -->
  <div>

    <Head />
    <!-- 投资机构的头部nav -->
    <DockingSystemHead />
    <!-- 投资机构的头部搜索栏 -->
    <DockingSystemSearch />
    <!-- 筛选框架 -->
    <SizerFrame @selectChange="selectChange" />
    <!-- 投资机构 -->
    <InvestmentOrganization :list="InvestmentList" />
    <!-- 分页器 -->
    <PagingDevice :pageNum="pageNum" />
    <Foot />
  
  </div>
</template>

<script>
  import Head from "@/components/Head/Head.vue";
  import Foot from "@/components/Foot/Foot.vue";
  import DockingSystemHead from "@/components/DockingSystem/Head/DockingSystemHead.vue";//投资机构的头部nav
  import DockingSystemSearch from "@/components/DockingSystem/Search/DockingSystemSearch.vue";//投资机构的头部搜索栏
  import SizerFrame from "@/components/DockingSystem/Sizer/SizerFrame.vue";//筛选框架
  import InvestmentOrganization from "@/components/DockingSystem/ActivityFrame/InvestmentOrganization.vue";//投资机构活动框
  import PagingDevice from "@/components/DockingSystem/PagingDevice/PagingDevice.vue";//分页器
  import axios from "axios"
  export default {
    props: {},
    components: {
      Head, Foot, DockingSystemHead, DockingSystemSearch, SizerFrame, InvestmentOrganization, PagingDevice
    },
    data() {
      return {
        InvestmentList: [],//内容数据
        pageNum: 48,//数据的总数


      }
    },
    created: function () {
      let self = this;
      //获取领域
      self.getCloudDockingList('', '', 6, 1);
      //初始化加载，默认内容
    },
    methods: {

      selectChange(payload) {

        let self = this;
        // console.log('payload', payload);
        let territorytype = '';//领域ID
        let timetype = '';//融资轮次

        switch (payload.select) {
          case 'fieldSelect':
            territorytype = payload.item.id;
            break;
          //领域选择
          case 'timeSelect':
            timetype = payload.item.id;
            break;
          //融资轮次-时间选择
          case 'regionSelect':
            break;
          //地区选择

        }
        self.getCloudDockingList(territorytype, timetype, 8, 1)
      },
      getCloudDockingList(territorytype, timetype, limit, page) {
        let self = this;
        //获取云对接
        axios.get('/api/jointorganizationlist', {
          params: {
            territorytype: territorytype,//领域ID
            timetype: timetype,//融资轮次
            limit: limit,//循环条数
            page: page,//页数
          }
        })
          .then(function (response) {
            if (response.data.code == 0) {
              self.InvestmentList = response.data.data
            }
          })
          .catch(function (error) {
            console.log(error);
          });

      },

    },

  }
</script>

<style scoped>



</style>